import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type X6Machine } from "@packsize/schemas/machines";

import { getX6Machines } from "@/api/machines/x6-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { X6_MACHINES_QUERY_KEY } from "./query-keys";

const REFETCH_INTERVAL = 15 * 1000;

export const getX6MachinesQuery = <TData = X6Machine[], TError = Error>(
	options?: UseMachinesQueryOptions<TData, TError>,
) => ({
	queryKey: X6_MACHINES_QUERY_KEY,
	queryFn: getX6Machines,
	refetchInterval: REFETCH_INTERVAL,
	staleTime: 10 * 1000,
	...options,
});

export const useX6Machines = (
	options?: UseMachinesQueryOptions<X6Machine[], Error>,
): UseQueryResult<X6Machine[], Error> => {
	return useQuery<X6Machine[], Error>(getX6MachinesQuery(options));
};
